// extracted by mini-css-extract-plugin
module.exports = {"usedVehicles":"bB","usedVehiclesTitle":"bC","usedVehiclesContainer":"bD","usedVehiclesItem":"bE","usedVehiclesButton":"bF"};